import PermissionsComponents from "./permissions/components";
import ACLTask from "./task";
import ACLProject from "./project/project";
import AccessControl_Company from "./company/check-company-rules";
import {CompanyRole, CompanyRoleLabel} from "../const/company-role";
import {ACL_CONFIG} from "./acl";

// const debug = "@AccessControl"
const debug = false

export default class AccessControl {

    public acl          : any
    public check        : any
    public task         : ACLTask
    public project      : ACLProject
    public components   : PermissionsComponents
    public company      : AccessControl_Company

    constructor() {

        this.acl        = ACL_CONFIG
        this.check      = require('./check-rules');

        this.task       = new ACLTask({todoConfig: 'from gd.company.settings'})
        this.project    = new ACLProject({})
        this.company    = new AccessControl_Company()
        this.components = new PermissionsComponents()

    }

    init() {

        debug && console.log(debug, ".init");

        if (!gd.companyId) return;

    }

    getAppAccess() {
        debug && console.log(debug,".get()",arguments);

        const acl : false | any = this.getACL();

        if (!acl) {
            console.error("No ACL found",gd.getApp().name);
            return false;
        }

        debug && console.log(debug,"acl=",acl);

        const app = gd.getApp() as any;

        const projectAccessName = (app.projectAccess)?gd.const.project.accessList[app.projectAccess].toLowerCase():'---';

        if (debug) {
            // const orgRoleName = (app.organizationRole)?gd.const.companyRoleList[app.organizationRole]:'---';
            // const taskRoleName = (app.taskRole)?app.taskRole:'---';
            // console.log(debug,"orgRole: ",orgRoleName,"     projectAccess: ",projectAccessName,"      taskRole:",taskRoleName);
        }

        let acValue;

        if (acl.taskRole) {
            // @ts-ignore
            acValue = acl.taskRole[this.taskRoleToAclName(app.taskRole)];
            if (acValue) {
                debug && console.log(debug,"AC based on TASK role =",acValue);
                return acValue;
            }
        }

        if (acl.projectAccess) {
            acValue = acl.projectAccess[projectAccessName];
            if (acValue) {
                debug && console.log(debug,"AC based on PROJECT role =",acValue);
                return acValue;
            }

        }

        if (acl.organizationRole) {
            // @ts-ignore
            acValue = acl.organizationRole[this.organizationRoleToAclName(app.organizationRole)];
            if (typeof(acValue)!== "undefined" && acValue!==null) {
                debug && console.log(debug,"AC based on ORGANIZATION role =",acValue);
                return acValue;
            }

        }

        return false;
    }

    getACL() : false | any {

        const appSystemName = gd.getApp().name;

        debug && console.log(debug,".getACL() app=",appSystemName);

        if (!appSystemName) {
            console.error("App has no name");
            return false;
        }

        const chunks = appSystemName.split("-");

        for (let i=chunks.length; i>=1; i--) {
            var subArr = chunks.slice(0,i);
            var nameToCheck = subArr.join('-');

            if (this.acl[nameToCheck]) {
                debug && console.log(debug,"ACL name=",nameToCheck);
                return this.acl[nameToCheck];
            }
        }

        return false;

    }

    organizationRoleToAclName(companyRole:CompanyRole):string|false {

        if (!companyRole) return false;

        return CompanyRoleLabel[companyRole]

        // switch (organizationRole) {
        //     case CompanyRole.MANAGER:
        //         return 'manager';
        //     case gd.const.companyRole.USER:
        //         return 'user';
        //     case gd.const.companyRole.GUEST:
        //     case gd.const.companyRole.CLIENT:
        //         return 'guest';
        //     default:
        //         console.error('AccessControl: organization role unknown or missing - ['+organizationRole+"]");
        //         return false;
        // }
    }

    taskRoleToAclName(taskRole:any) {

        if (!taskRole) return false;

        switch (taskRole) {
            case gd.const.task.role.CREATOR: return 'creator'; break;
            case gd.const.task.role.ASSIGNEE: return 'assignee'; break;
            case gd.const.task.role.COLLABORATOR: return 'collaborator'; break;
            default:
                console.error('AccessControl: task role unknown or missing - ['+taskRole+"]");
                return false;
        }
    }

}

